import { DiagnosticImageProcessEnum } from '../../../types/diagnostic-image'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { Flex, Box, Text } from '@chakra-ui/react'
import ProcessingMsg from '../../_shared/ProcessingMsg'
import { useTranslation } from 'react-i18next'

const ReportStatusMsg = ({
  reportProcess,
}: {
  reportProcess: DiagnosticImageProcessEnum
}) => {
  const { t } = useTranslation()
  const isReportFailed = reportProcess === DiagnosticImageProcessEnum.Failed
  const isReportInProgress =
    reportProcess === DiagnosticImageProcessEnum.InProgress
  return (
    <>
      {isReportFailed && (
        <Flex align={'center'} gap={2} mb={4}>
          <InfoOutlineIcon color={'red.400'} />
          <Text
            color={'red.400'}
            fontSize="md"
            fontWeight="medium"
            fontStyle={'italic'}
          >
            {t('ai.malaria.atLeastOneFailedMsg')}
          </Text>
        </Flex>
      )}
      {isReportInProgress && (
        <Box mb={4}>
          <ProcessingMsg />
        </Box>
      )}
    </>
  )
}

export default ReportStatusMsg
